import Vue from 'vue';
import App from './App.vue';

/**
 * Service worker for PWA
 */
import './registerServiceWorker';

/**
 * Import store and router
 */
import store from './app/store';
import router from './app/router';
import './app/api/client.api';
import './app/api/admin.api';
/**
 * Import helper functions and mixins
 */
import './shared/mixins';
import './shared/helpers';

/**
 * Import plugins
 */
import './plugins/element';
import './plugins/phone-number-input';

import './scss/main.scss';
import './plugins/vue-the-mask';
import './plugins/vue-cookie';
import './plugins/amplitude';

/**
 * Import AWS
 */
import './app/aws/amplify';

/**
 * Multilanguage
 */
import i18n from './app/i18n';

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
